import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootPrintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_file_transfer_moveService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { service_endpoint: string, container_name: string, authentication: { st: string, se: string, sv: string, sig: string }, file_extenstion?: string, source_folder: string, target_folder: string }): Promise<{ messages?: any[], success?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.service_endpoint)) {
      missingRequiredInParams.push('\'service_endpoint\'');
    }
    if (isNil(inParams.container_name)) {
      missingRequiredInParams.push('\'container_name\'');
    }
    if (isNil(inParams.authentication)) {
      missingRequiredInParams.push('\'authentication\'');
    }
    if (isNil(inParams.source_folder)) {
      missingRequiredInParams.push('\'source_folder\'');
    }
    if (isNil(inParams.target_folder)) {
      missingRequiredInParams.push('\'target_folder\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

